import { useQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { SessionDebugSummary } from "../ChatDebugRecord";

/**
 * Fetch per-turn token usage and session totals for an admin chat.
 *
 * Returns an empty summary for chats with no captured debug data (e.g. chats
 * that predate debug capture).
 */
export function useChatDebugSummary(chatId: string) {
  const { adminService } = useDomainServices();

  return useQuery<SessionDebugSummary, Error>({
    queryKey: ["adminChatDebug", chatId],
    queryFn: ({ signal }) =>
      adminService.getChatDebugSummary(chatId, { abortSignal: signal }),
    enabled: !!chatId,
    staleTime: 30000,
  });
}
